// extracted by mini-css-extract-plugin
export default {"wrapper":"user-stats_wrapper__-bJRS","avatar":"user-stats_avatar__WNuXb","name":"user-stats_name__CWXiR","info":"user-stats_info__-hRcj","date":"user-stats_date__qjLmZ"};